import { useState, useEffect, useContext } from 'react';
import { Eye, Clock, Download, ChevronUp, ChevronDown, Smartphone, Search, Monitor } from 'react-feather'
import { format, subYears } from 'date-fns';
import { useHistory } from 'react-router';
import { useStorage, useRemote } from '../../../Utils/Utils';
import { BannerContext } from '../../../InternalApiApp';
import { minutesIntoReadableFormat } from '../../../Utils/Utils';
import { PAGES, ROUTE_PATHS } from '../../../InternalApiApp';
import Page, { PageContentBodyGrid } from '../../Shared/Page/Page';
import PageGridItem from '../../Shared/Page/PageGridItem';
import PageContentToggle from '../../../components/Menus/PageContentToggle'
import SimpleSearchFilter, { filterBy } from '../../../components/Input/SimpleSearchFilter'
import Table from '../../../components/Table/Table';
import FlexWrapper from '../../FlexWrapper';
import PageGridDivider from '../../Shared/Page/PageGridDivider';
import Divider from '../../../components/Divider';
import TickerSectorItem from '../../../components/TickerSectorItem';
import AnalyticsMetricFilter from '../../../components/Analytics/AnalyticsMetricFilter';
import LoadingIcon from '../../Shared/LoadingIcon';
import AnalyticsSourceSelector from "../AnalyticsSourceSelector";


const AnalyticsManagerPage = ({ datatita/*, jsonFile*/ }) => {
    const { setBannerBreadCrumbs, setBannerAdditionalContent, setBacNoDivider } = useContext(BannerContext);
    const storage = useStorage();
    const remote = useRemote();
    const managerId = datatita.match.params.managerId
    const history = useHistory();
    // states
    const [loading, setLoading] = useState(true);
    const [currentView, setCurrentView] = useState("Downloads");
    const [downloads, setDownloads] = useState([])
    const [views, setViews] = useState([])
    const [manager, setManager] = useState(null);
    const [sortingColumn, setSortingColumn] = useState({ column: "initiated", ascending: false })
    const [searchTerm, setSearchTerm] = useState("")
    const [managerLogoSrc, setManagerLogoSrc] = useState(null)
    const [metricsViews, setMetricsViews] = useState("-");
    const [metricsUniqueViews, setMetricsUniqueViews] = useState("-");
    const [avgDuration, setAvgDuration] = useState("-");
    const [fundsObj, setFundsObj] = useState({});


    useEffect(() => {
        // TODO: Replace enpoints with manager specific endpoints for Total Metrics, Downloads and Views
        storage.getOrFetch(`/funds/funds2`).then(fetchedFunds => {
            const fundsObj1 = fetchedFunds.reduce((a, c) => ({ ...a, [c.id]: c }), {})
            const fundsObj2 = fetchedFunds.reduce((a, c) => ({ ...a, [c.fundNumber]: c }), {})
            const fundsObj3 = fetchedFunds.reduce((a, c) => ({ ...a, [c.fundName]: c }), {})

            remote.get("analytics/aggregates/groupings").then((fetchedGroupings) => {
                const managerGrouping = fetchedGroupings.find((grouping) => grouping.groupingName === 'Manager')
                const group = managerGrouping.groups.find((group) => group.groupId == managerId)
                setMetricsUniqueViews(group.views)
            })

            storage.getOrFetch(`funds/funds/groupings`).then(fetchedGroupings => {
                const allManagers = fetchedGroupings.length > 0 ? fetchedGroupings.find((g) => g.groupingName === "Manager").groups : []
                const managersObj = allManagers.reduce((a, c) => ({ ...a, [c.groupId]: c }), {})
                const fundsNumbers = managersObj[managerId].funds.map(fund => fundsObj1[fund].fundNumber)

                setBannerBreadCrumbs({ tab: 'Managers', param1: { name: managersObj[managerId].groupName, id: managerId } })
                setBacNoDivider(true)
                setBannerAdditionalContent(<AnalyticsSourceSelector />)

                storage.getOrFetch(`/analytics/aggregates/webpage?from=${format(subYears(new Date, 6), 'yyyy-MM-dd')}&to=${format(new Date, 'yyyy-MM-dd')}`).then(fetchedWebPages => {
                    const relevantWebPages = fetchedWebPages.filter((webPage) => {
                        const arr = webPage.path.split("/portfolio/")
                        const arr2 = arr[arr.length - 1].split("/")
                        const tickerId = arr2[0]
                        return fundsNumbers.includes(tickerId)
                    })

                    // Calculate Total Metrics
                    const totalViews = relevantWebPages && relevantWebPages.length > 0 ? relevantWebPages.reduce((acc, webPage) => acc + (webPage.count || 0), 0) : null
                    const totalDuration = relevantWebPages && relevantWebPages.length > 0 ? relevantWebPages.reduce((acc, webPage) => acc + (webPage.minutes || 0), 0) : null

                    // Get Views Data
                    const portfolioAggregate = {};

                    relevantWebPages.forEach(r => {
                        const arr = r.path.split("/portfolio/")
                        const arr2 = arr[arr.length - 1].split("/")
                        const ticker = arr2[0]
                        const portfolioStats = portfolioAggregate[ticker]
                            ? { ticker: ticker, portfolio: fundsObj2[ticker]?.fundName, count: portfolioAggregate[ticker].count + r.count, minutes: portfolioAggregate[ticker].minutes + r.minutes }
                            : { ticker: ticker, portfolio: fundsObj2[ticker]?.fundName, count: r.count, minutes: r.minutes };

                        portfolioAggregate[ticker] = portfolioStats;
                    })
                    const portfolioArray = Object.keys(portfolioAggregate).map(key => portfolioAggregate[key])

                    // Get Manager Logo
                    storage.getOrFetch(`/funds/portfolio/group/${managerId}/static-data`).then(fetchedStaticData => {
                        const staticObj = fetchedStaticData.reduce((a, c) => ({ ...a, [c.key]: c }), {})
                        const src = staticObj && staticObj["pm_logo"] ? staticObj["pm_logo"].value.replace("url:", "") : null

                        Promise.all(
                            // Get Downloads Data
                            fundsNumbers.map(f => {
                                return storage.getOrFetch(`/analytics/fund/${f}/downloads`).then(fetchedDownloads => {
                                    const downloadsWithPortfolio = fetchedDownloads.map(d => {
                                        return { ...d, portfolio: fundsObj2[f].fundName }
                                    })
                                    const downloadsPromise = [downloadsWithPortfolio].flat()
                                    return Promise.all(downloadsPromise);
                                });
                            })).then(results => {
                                // Set all states
                                setFundsObj(fundsObj3)
                                setManagerLogoSrc(src)
                                setManager(managersObj[managerId] || null)
                                setDownloads(results.flat())
                                setMetricsViews(totalViews ? totalViews : "-")
                                setAvgDuration(totalDuration || totalDuration === 0 ? totalDuration > 0 ? minutesIntoReadableFormat(Math.ceil(totalDuration / totalViews)) : 0 + "m" : "-")
                                setViews(portfolioArray)
                                setLoading(false);
                            })
                    })
                })
            }).catch(() => setLoading(false))
        })
        return () => {
            setBacNoDivider(false)
            setBannerAdditionalContent(null)
        }
    }, [])

    function handleSort(a, b) {
        const { column, ascending } = sortingColumn;
        if (a[column] && typeof a[column] === 'number' && b[column] && typeof b[column] === 'number') {
            return ascending ? a[column] - b[column] : b[column] - a[column];
        } else if (a[column] === 0 || b[column] === 0) {
            return ascending ? (a[column] || 0) - (b[column] || 0) : (b[column] || 0) - (a[column] || 0);
        } else if (a[column] && typeof a[column] === 'string' && b[column] && typeof b[column] === 'string') {
            return ascending ? a[column].localeCompare(b[column]) : b[column].localeCompare(a[column]);
        }
    }

    function filterData(dataToFilter) {
        if (searchTerm === null || searchTerm.trim().size === 0) {
            return dataToFilter
        }
        return dataToFilter.filter((datum) => filterBy(datum, ["device", "browser", "locationCity", "locationCountry", "downloadType", "portfolio"], searchTerm))
    }

    function changeTab(string) {
        if (string === "Downloads") {
            setCurrentView("Downloads")
            setSortingColumn({ column: "initiated", ascending: false })
        }
        if (string === "Views") {
            setCurrentView("Views")
            setSortingColumn({ column: "count", ascending: false })
        }
    }

    // Manager metrics
    const metricsDownloads = downloads ? downloads.length : "-"

    // downloads table data 
    const downloadsColWidths = ["280px", "280px", "180px", "280px", "180px", "100px"]
    const downloadsHeaders = [
        {
            text: (
                <div className='sorting-header' onClick={() => setSortingColumn({ ascending: !sortingColumn.ascending, column: "initiated" })}>
                    <div className={sortingColumn.column === "initiated" ? "font-weight-semi-bold" : ""}>Time/Date</div>
                    {sortingColumn && sortingColumn.column === "initiated" && sortingColumn.ascending === true ?
                        <ChevronUp className="colour-text-primary" size={12} /> :
                        <ChevronDown className={sortingColumn && sortingColumn.column === "initiated" ? "colour-text-primary" : "colour-text-neutral-dark-30"} size={12} />
                    }
                </div>
            )
        },
        {
            text: (
                <div className='sorting-header' onClick={() => setSortingColumn({ ascending: !sortingColumn.ascending, column: "portfolio" })}>
                    <div className={sortingColumn.column === "portfolio" ? "font-weight-semi-bold" : ""}>Portfolio</div>
                    {sortingColumn && sortingColumn.column === "portfolio" && sortingColumn.ascending === true ?
                        <ChevronUp className="colour-text-primary" size={12} /> :
                        <ChevronDown className={sortingColumn && sortingColumn.column === "portfolio" ? "colour-text-primary" : "colour-text-neutral-dark-30"} size={12} />
                    }
                </div>
            )
        },
        {
            text: (
                <div className='sorting-header' onClick={() => setSortingColumn({ ascending: !sortingColumn.ascending, column: "downloadType" })} >
                    <div className={sortingColumn.column === "downloadType" ? "font-weight-semi-bold" : ""}>Download Type</div>
                    {sortingColumn && sortingColumn.column === "downloadType" && sortingColumn.ascending === true ?
                        <ChevronUp className="colour-text-primary" size={12} /> :
                        <ChevronDown className={sortingColumn && sortingColumn.column === "downloadType" ? "colour-text-primary" : "colour-text-neutral-dark-30"} size={12} />
                    }
                </div>
            )
        },
        {
            text: (
                <div className='sorting-header' onClick={() => setSortingColumn({ ascending: !sortingColumn.ascending, column: "locationCity" })} >
                    <div className={sortingColumn.column === "locationCity" ? "font-weight-semi-bold" : ""}>User Location</div>
                    {sortingColumn && sortingColumn.column === "locationCity" && sortingColumn.ascending === true ?
                        <ChevronUp className="colour-text-primary" size={12} /> :
                        <ChevronDown className={sortingColumn && sortingColumn.column === "locationCity" ? "colour-text-primary" : "colour-text-neutral-dark-30"} size={12} />
                    }
                </div>
            )
        },
        {
            text: (
                <div className='sorting-header' onClick={() => setSortingColumn({ ascending: !sortingColumn.ascending, column: "browser" })} >
                    <div className={sortingColumn.column === "browser" ? "font-weight-semi-bold" : ""}>Browser</div>
                    {sortingColumn && sortingColumn.column === "browser" && sortingColumn.ascending === true ?
                        <ChevronUp className="colour-text-primary" size={12} /> :
                        <ChevronDown className={sortingColumn && sortingColumn.column === "browser" ? "colour-text-primary" : "colour-text-neutral-dark-30"} size={12} />
                    }
                </div>
            )
        },
        {
            text: (
                <div className='sorting-header centered' onClick={() => setSortingColumn({ ascending: !sortingColumn.ascending, column: "device" })} >
                    <div className={sortingColumn.column === "device" ? "font-weight-semi-bold" : ""}>Device</div>
                    {sortingColumn && sortingColumn.column === "device" && sortingColumn.ascending === true ?
                        <ChevronUp className="colour-text-primary" size={12} /> :
                        <ChevronDown className={sortingColumn && sortingColumn.column === "device" ? "colour-text-primary" : "colour-text-neutral-dark-30"} size={12} />
                    }
                </div>
            )
        }
    ];

    const downloadsDataMap = (data) => data && data.length > 0 && data.map((datum, idx) => {
        const { device, browser, downloadType, locationCity, locationCountry, initiated, portfolio } = datum       // change once the endpoint is implemented
        const location = (locationCity == null && locationCountry == null) ? "Unknown" : locationCity + ", " + locationCountry
        const portfolioNumber = portfolio ? fundsObj[portfolio]?.fundNumber : null
        return (
            <tr style={{ cursor: 'pointer' }} key={idx} onClick={() => portfolioNumber ? history.push(`${ROUTE_PATHS[PAGES.ANALYTICS]}/portfolios/${portfolioNumber}`) : null}>
                <td>{initiated ? format(new Date(initiated), "hh:mmaaa dd/MM/yyyy") : "-"}</td>
                <td>{portfolio || "-"}</td>
                <td>{downloadType || "-"}</td>
                <td>{location || "-"}</td>
                <td>{browser || "-"}</td>
                <td className="text-align-center">
                    {device === "mobile"
                        ? <Smartphone size={24} style={{ transform: "translateY(-1px)" }} color="#0A70C9" />
                        : device === "desktop"
                            ? <Monitor size={24} style={{ transform: "translateY(-1px)" }} color="#0E8EFD" />
                            : "-"
                    }</td>
            </tr>
        );
    });
    // downloads table data 
    const viewsColWidths = ["280px", "280px"]
    const viewsHeaders = [
        {
            text: (
                <div className='sorting-header' onClick={() => setSortingColumn({ ascending: !sortingColumn.ascending, column: "portfolio" })}>
                    <div className={sortingColumn.column === "portfolio" ? "font-weight-semi-bold" : ""}>Portfolio</div>
                    {sortingColumn && sortingColumn.column === "portfolio" && sortingColumn.ascending === true ?
                        <ChevronUp className="colour-text-primary" size={12} /> :
                        <ChevronDown className={sortingColumn && sortingColumn.column === "portfolio" ? "colour-text-primary" : "colour-text-neutral-dark-30"} size={12} />
                    }
                </div>
            )
        },
        {
            text: (
                <div className='sorting-header centered' onClick={() => setSortingColumn({ ascending: !sortingColumn.ascending, column: "count" })}>
                    <div className={sortingColumn.column === "count" ? "font-weight-semi-bold" : ""}>Views</div>
                    {sortingColumn && sortingColumn.column === "count" && sortingColumn.ascending === true ?
                        <ChevronUp className="colour-text-primary" size={12} /> :
                        <ChevronDown className={sortingColumn && sortingColumn.column === "count" ? "colour-text-primary" : "colour-text-neutral-dark-30"} size={12} />
                    }
                </div>
            )
        },
    ];

    const viewsDataMap = (data) => data && data.length > 0 && data.map((datum, idx) => {
        const { portfolio, count } = datum       // change once the endpoint is implemented
        const portfolioNumber = portfolio ? fundsObj[portfolio]?.fundNumber : null
        return (
            <tr style={{ cursor: 'pointer' }} key={idx} onClick={() => portfolioNumber ? history.push(`${ROUTE_PATHS[PAGES.ANALYTICS]}/portfolios/${portfolioNumber}`) : null}>
                <td>{portfolio || "-"}</td>
                <td className='text-align-center'>{count || "-"}</td>
            </tr>
        );
    });

    const filteredData = (passedData) => filterData(passedData)

    if (!manager) {
        return (
            <Page noBanner showScrollbar>
                <PageContentBodyGrid showScrollbar>
                    <PageGridItem colSpan="12">
                        <LoadingIcon centered />
                    </PageGridItem>
                </PageContentBodyGrid>
            </Page>
        )
    }

    return (
        <Page noBanner noOverflownY>
            {/* model */}
            <PageContentBodyGrid showScrollbar style={{ height: "calc(100% - 7rem)" }}>
                <PageGridItem colSpan="12">
                    <FlexWrapper gap="xl">
                        <FlexWrapper gap="xs" direction="column" align="flex-start">
                            {/*TODO: update image url*/}
                            <TickerSectorItem imageClass='manager-logo-image-container' label={manager.groupName} filename={manager.groupName} image={managerLogoSrc} />
                        </FlexWrapper>
                        <Divider vertical height={40} />
                        <AnalyticsMetricFilter
                            label="Unique Views"
                            icon={<Eye />}
                            count={metricsUniqueViews}
                            pointer
                        />
                        <AnalyticsMetricFilter
                            label="Total Views"
                            icon={<Eye />}
                            count={metricsViews}
                            pointer
                        />
                        <AnalyticsMetricFilter
                            label="Avg Duration"
                            icon={<Clock />}
                            count={avgDuration}
                            pointer
                        />
                        <AnalyticsMetricFilter
                            label="Downloads"
                            icon={<Download color='#00805e' />}
                            count={metricsDownloads}
                            pointer
                        />
                    </FlexWrapper>
                </PageGridItem>
                <PageGridDivider colSpan="12" />
                <PageGridItem colSpan="12">
                    <FlexWrapper gap="m">
                        <PageContentToggle labels={[
                            { label: "Downloads", active: currentView === "Downloads", onClick: () => changeTab("Downloads") /*setCurrentView("research") */ },
                            { label: "Views", active: currentView === "Views", onClick: () => changeTab("Views") /*setCurrentView("watching")*/ },
                        ]} />
                        <Divider vertical height={24} />
                        <SimpleSearchFilter
                            size="small"
                            width="l"
                            placeholder={`Search`}
                            isClearable
                            // disabled={currentView !== "Downloads"}
                            icon={<Search />}
                            searchTerm={searchTerm}
                            setSearchTerm={setSearchTerm}
                        />

                    </FlexWrapper>
                </PageGridItem>
                <PageGridDivider colSpan="12" />
                {currentView === 'Downloads' &&
                    <PageGridItem colSpan="12" style={{ paddingTop: "0.5rem" }}>
                        <Table
                            minWidth={1000}
                            tableStyle={{ maxWidth: 1200 }}
                            colWidths={downloadsColWidths}
                            headers={downloadsHeaders}
                            dataMap={downloadsDataMap(filteredData(downloads).sort(handleSort))}
                            dataLoading={loading}
                            suggestionMessage
                        />
                    </PageGridItem>
                }
                {currentView === 'Views' &&
                    <PageGridItem colSpan="12" style={{ paddingTop: "0.5rem" }}>
                        <Table
                            minWidth={1000}
                            tableStyle={{ maxWidth: 1200 }}
                            colWidths={viewsColWidths}
                            headers={viewsHeaders}
                            dataMap={viewsDataMap(filteredData(views).sort(handleSort))}
                            dataLoading={loading}
                            suggestionMessage
                        />
                    </PageGridItem>
                }
            </PageContentBodyGrid>
        </Page>
    );
}

export default AnalyticsManagerPage;